import { createElement } from 'rlink-react';

export default function IconLocation (props) {
  return (
    <svg id="Layer_1" viewBox="0 217.9 595.3 394.7" {...props}>
      <g id="m1">
        <path fill="#FAE71D" d="M293.8 229.7L39.6 611.2h478.6z" />
        <path d="M293.4 241.9L261 289.6l18.7 28.9 18.9-38.7 13.1 17.2 9-11.3z" />
      </g>
      <g id="m2">
        <path
          fill="#FAE71D"
          d="M171.8 320.4l132.7 292.2-301.6-.4 100.5-209.8 26.4 32.6z" />
        <path d="M171.8 337.4l-28.9 78.7 14.1 18 20.7-43.3 31.2 77.7 7.8-14.6 69.9 151.8s6.8.4 6.2-1c-.6-1.5-121-267.3-121-267.3z" />
      </g>
      <g id="m3">
        <path
          fill="#FAE71D"
          d="M462.2 388.7l-269 223.5h401.1l-82-157.1-14.2 10.3z" />
        <path d="M459 399.9L207.9 606h11.7l178.9-148 12.3 14.7 22.5-19.6 24.4 36.5 34.5-22.2z" />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/svg/iconLocation.jsx